import React from 'react';
import {
  Alert,
  Button,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';

import { IOverviewPanelProps } from './PlanningControlCenter.types';

export default class PlanningOverviewPanel extends React.PureComponent<
  IOverviewPanelProps
> {
  render(): React.ReactNode {
    const { overview, busy, onChangeCycle } = this.props;

    return (
      <Stack spacing={2}>
        <Alert severity="info">
          This is the Planning Cycle currently being configured. Selecting a
          cycle here does not silently activate it as Planning Context.
        </Alert>

        <Grid container spacing={2}>
          {[
            ['Planning Cycle', overview.pcn],
            ['Code', overview.pcc],
            ['Budget Period', overview.bpn || overview.bpc || '—'],
            ['Start', overview.bps || '—'],
            ['End', overview.bpe || '—'],
            ['State', overview.sts === 1 ? 'Active' : 'Inactive'],
          ].map(([label, value]) => (
            <Grid size={{ xs: 12, md: 6 }} key={label}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  {label}
                </Typography>
                <Typography fontWeight={700}>{value}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Stack direction="row">
          <Button
            color="inherit"
            startIcon={<SwapHorizOutlinedIcon />}
            disabled={busy}
            onClick={onChangeCycle}
          >
            Select or Create Another Cycle
          </Button>
        </Stack>
      </Stack>
    );
  }
}
